import { addStyles } from 'ethcss'
import { colors, IStyles, mediaCSS } from 'theme'

const channelAdd: IStyles = {
    unitAdd: {
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: 'rgba(0,0,0,0.7)',
        zIndex: 2000,
    },
    inner: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        //borderRadius: 20,
        filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))',
        backgroundColor: colors.white,
        width: 'calc(100% - 20px)',
        maxWidth: 400,
        padding: 34,
        maxHeight: '90vh',
        overflow: 'auto',
        borderRadius: 16,
        '&::-webkit-scrollbar': {
            background: 'transparent',
            borderRadius: 10,
            width: 6,
            overflowX: 'hidden',
            overflowY: 'auto',
        },

        '&::-webkit-scrollbar-thumb': {
            borderRadius: 10,
            width: 6,
            background: '#b3b3b3',
        },
    },
    field: {
        marginBottom: 20,
    },
    controls: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 60,
    },
    button: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 148,
        height: 34,
    },
    selectLogo: {
        width: '100%',
    },
    itemStyles: {
        width: '100% !important',
        border: `1px solid ${colors.greyLight}`,
    },
    recommendedImage: {
        marginTop: 10,
    },
    devices: {
        marginTop: 20,
        marginBottom: 7,
    },
    deleteDevices: {
        position: 'absolute',
        top: 84,
        right: 8,
        opacity: 0,
        transition: 'opacity 0.3s',
    },
    deleteFloor: {
        position: 'absolute',
        top: 6,
        right: 4,
        opacity: 0,
        transition: 'opacity 0.3s',
        zIndex: 1,
    },
    floor: {
        position: 'relative',
        border: `1px solid ${colors.greyLight}`,
        borderRadius: 10,
        padding: 10,
        marginBottom: 10,

        '&:hover': {
            div: {
                opacity: 1,
            },
        },
    },
    floorTitle: {
        marginBottom: 14,
    },
    floorList: {
        marginBottom: 14,
    },
    devicesTitle: {
        margin: '14px 0 10px 0',
    },
    device: {
        display: 'flex',
        marginBottom: 14,
    },
    deviceName: {
        marginLeft: 8,
    },
    confirmDisplaysMoveWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 12,
    },
    confirmDisplaysMoveText: {
        textAlign: 'center',
        fontSize: 14,
        color: '#333',
        maxWidth: 480,
    },

    confirmDisplaysMoveTable: {
        width: '100%',
        borderCollapse: 'collapse',
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
    },
    tableRow: {
        display: 'grid',
        gridTemplateColumns: '2fr 2fr 1fr',
        gap: 8,
        fontSize: 13,
        color: '#222',
    },
    tableHeader: {
        fontWeight: 'bold',
        paddingBottom: 4,
    },
    buttonRow: {
        display: 'flex',
        justifyContent: 'center',
        gap: 12,
        marginTop: 20,
    },
    tableCell: {
        textAlign: 'center',
    },
}

addStyles(channelAdd)
export default channelAdd
